module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "size": "m",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.params.isActive = false;
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('section', {
    staticClass: "delete-brand"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$trad.common.disable) + " " + _vm._s(_vm.params.zone.name.toUpperCase()))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.$t('zonerole.deleteZone', {
        zone: _vm.params.zone.name.toUpperCase()
      })),
      expression: "$t('zonerole.deleteZone', { zone: params.zone.name.toUpperCase() })"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "row d-flex justify-content-end"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "background-color": _vm.currentBrand.linksColor
    },
    on: {
      "click": function($event) {
        _vm.disableBrandZone();
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.disable))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.params.isActive = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))])], 1)])])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70696dca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/DisableZone.vue
// module id = 3261
// module chunks = 0